/**
 * Google Analytics (GA4) helpers.
 *
 * The gtag script is only loaded in production builds so local development
 * traffic does not pollute reports. Page views are sent manually on route
 * change (see hooks/usePageTracking) because this is a single-page app.
 */
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID || 'G-576LF8NDG0';

const isEnabled = () => process.env.NODE_ENV === 'production' && !!GA_MEASUREMENT_ID;

export function initGA() {
  if (!isEnabled() || window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!isEnabled() || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!isEnabled() || !window.gtag) return;
  window.gtag('event', name, params);
}
